import React from 'react';
import { Heart, Leaf, Sparkles, Users, Sun } from 'lucide-react';

const items = [
  { Icon: Heart, title: 'Compassionate Care', text: 'You’re seen. You’re heard. You matter.' },
  { Icon: Leaf, title: 'Experienced Clinicians', text: 'Highly trained, deeply committed to you.' },
  { Icon: Sparkles, title: 'Evidence-Based Treatment', text: 'Proven approaches for lasting change.' },
  { Icon: Users, title: 'Support for Every Stage', text: 'Children, teens, adults, couples, & families.' },
  { Icon: Sun, title: 'Inspiration & Growth', text: 'Helping you rediscover your strength and your light.' },
];

export default function TrustBar() {
  return (
    <section style={{ background: 'var(--sage-green)' }} className="relative">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-2 md:grid-cols-5 stagger">
          {items.map(({ Icon, title, text }, i) => (
            <div key={title} className="trust-card px-4 py-7 md:py-9 text-center text-white reveal-scale group">
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-full border border-white/40 flex items-center justify-center mx-auto mb-3 backdrop-blur-sm icon-hover">
                <Icon className="w-5 h-5 md:w-6 md:h-6" strokeWidth={1.4} />
              </div>
              <h3 className="font-serif-display uppercase tracking-[0.14em] text-xs md:text-[13px] text-white font-bold mb-1.5">{title}</h3>
              <p className="text-[13px] text-white/90 leading-relaxed max-w-[15rem] mx-auto">{text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
